import { useDispatch, useSelector } from "react-redux";
import {
  CreateTradingAccountReq,
  UserSearchReq,
} from "../../../utils/api/apis";
import "./style.scss";
import Select from "react-select";
import { useEffect, useState } from "react";
import { returnErrors } from "../../../store/reducers/error";
import { returnMessages } from "../../../store/reducers/message";
import { CircularProgress } from "@mui/material";
import { esAR } from "rsuite/esm/locales";
export const customStyles = {
  control: (provided) => ({
    ...provided,
    background: "none",
    width: "100%",
    marginTop: "0px",
    height: 60,
    borderRadius: 8,
    border: "1px solid #eaf0f8;",
    boxShadow: "none",
    fontFamily: "DM Sans, sans-serif",
    fontSize: "14px",
    fontWeight: 700,
    minHeight: "48px",
    height: "48px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "grey",
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "capitalize",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "48px",
    padding: "0 6px",
    fontWeight: 500,
    marginLeft: "10px",
    color: "#000",
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    color: "#000",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "48px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000",
    fontWeight: 500,
    textTransform: "capitalize",
  }),
  option: (provided, state) => ({
    ...provided,
    textTransform: "capitalize",
  }),
};

const CreateTradingAccount = () => {
  const [emailOpts, setEmailOpts] = useState([{ label: "", value: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  // User search by email
  const fetch = async (value) => {
    setIsLoading(true);
    const response = await UserSearchReq(idToken, value);
    setIsLoading(false);
    if (response?.status < 399) {
      let userArray = [];
      response.data.map((item) =>
        userArray.push({
          label: item?.email,
          value: item?.id,
        }),
      );

      setEmailOpts(userArray);
    } else {
      if (response.response.data.message) {
        return;
      }
      let msg = response?.response?.data?.detail || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  };

  // create trading account req
  const fundingData = useSelector((state) => state.funding.fundingData);
  const [planOptions, setPlanOptions] = useState([]);
  const [competitonOptions, setCompetitionOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [phase, setPhase] = useState(null);
  const [isSpinner, setIsSpinner] = useState(false);
  const { selectedBrand } = useSelector((state) => state.brand);

  const [selectedIssueType, setSelectedIssueType] = useState(null);

  const issueTypeOptions = [
    { value: "Affiliate", label: "Affiliate" },
    { value: "BOGO", label: "BOGO" },
    { value: "Giveaway", label: "Giveaway" },
    { value: "Retry", label: "Retry" },
    { value: "Test", label: "Test" },
    { value: "Other", label: "Other" },
  ];

  const phaseOptions = [
    ...(selectedOption?.label?.toLowerCase().includes("pro edge")
      ? [{ label: "Pro edge", value: "pro_edge" }]
      : selectedOption?.label?.toLowerCase().includes("instant")
        ? [{ label: "Instant", value: "pro_edge" }]
        : [
            { label: "Free", value: "free_trial" },
            { label: "Stage 1", value: "stage_1" },
            { label: "Stage 2", value: "stage_2" },
            { label: "Funded", value: "funded" },
          ]),
  ];

  const phaseCryptoOptions = [
    ...([16, 17].includes(selectedOption?.value)
      ? [{ label: "Stage 1", value: "stage_1" }]
      : []),

    ...([17].includes(selectedOption?.value)
      ? [{ label: "Stage 2", value: "stage_2" }]
      : []),
    ...([18, 17, 16].includes(selectedOption?.value)
      ? [{ label: "Funded", value: "funded" }]
      : []),
  ];
  const brokerOptions = [
    ...(selectedBrand?.brand === "equity_edge"
      ? [
          { label: "Match Trader", value: "matchtrade" },
          { label: "MT5", value: "mt5" },
          // { label: "Trade Locker", value: "tradelocker" },
        ]
      : [{ label: "CE Terminal", value: "ce_terminal" }]),
  ];
  const [data, setData] = useState(
    selectedBrand?.brand === "equity_edge"
      ? { broker: "matchtrade" }
      : { broker: "ce_terminal" },
  );
  const [broker, setBroker] = useState(brokerOptions[0]);

  // use Effects
  console.log(selectedOption, "selectedOptionselectedOption");

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setSelectedCompetition(null);

    if (selectedOption?.label?.toLowerCase().includes("pro edge")) {
      setPhase({ label: "Pro edge", value: "pro_edge" });
      setData((prev) => ({
        ...prev,
        phase: "pro_edge",
      }));
    } else if (selectedOption?.label?.toLowerCase().includes("instant")) {
      setPhase({ label: "Instant", value: "pro_edge" });
      setData((prev) => ({
        ...prev,
        phase: "pro_edge",
      }));
    } else {
      setPhase(null);
      setData((prev) => {
        const { phase, ...rest } = prev;
        return rest;
      });
    }
  };
  // Update phaseOptions

  console.log("selectedCompetition", selectedCompetition);

  const handleSelectCompetitionChange = (selectedOption) => {
    setSelectedCompetition(selectedOption);
  };
  useEffect(() => {
    let planArray = [];
    fundingData &&
      fundingData.forEach((item) => {
        planArray.push({ value: item.id, label: item.name });
      });
    setPlanOptions(planArray);
  }, [fundingData, broker]);

  useEffect(() => {
    let competitionArray = [];
    fundingData?.map((item) => {
      if (selectedOption?.value === item.id) {
        item?.challenges?.map((item) => {
          competitionArray.push({ value: item.id, label: item.name });
        });
      }
      setCompetitionOptions(competitionArray);
    });
  }, [selectedOption]);

  const CreateTradingAccount = async () => {
    if (!selectedIssueType) {
      dispatch(returnErrors("Please Select Issue Type", 400));
      return;
    }
    setIsSpinner(true);
    const response = await CreateTradingAccountReq(idToken, data);
    console.log("resb", response);
    if (response?.status < 399) {
      const accountNumber = response?.data.login_id; // "458891"
      const accountType = `${response?.data.plan_name} - $${response?.data?.challenge} - ${response?.data?.phase}`;

      // Helper to capitalize words
      const capitalizeWords = (str) =>
        str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
      const formattedAccountType = capitalizeWords(accountType);

      dispatch(
        returnMessages(
          `Created Account Successfully\nAccount Number: ${accountNumber}\nAccount Type: ${String(
            formattedAccountType,
          ).replace("_", " ")}`,
          201,
        ),
      );
      // dispatch(returnMessages("Created Account Successfully", 201));
    } else {
      let msg =
        response?.response?.data?.detail ||
        response?.response?.data[0] ||
        "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
    setIsSpinner(false);
  };

  const emailSelectorStyles = {
    ...customStyles,
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontWeight: 500,
      textTransform: "lowercase",
    }),
    option: (provided, state) => ({
      ...provided,
      textTransform: "lowercase",
    }),
  };

  let timeoutId = "";
  const handleOninputChange = (value) => {
    if (typeof value === "string" && value.length > 0) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fetch(value);
      }, 1500);
    }
  };
  return (
    <>
      <div className="create_trading_account">
        <div className="create_header">
          <p>Create Trading Account</p>
        </div>
        <div className="create_trading_account_wrapper">
          <div className="input_form">
            {/* <div className="input_form-top">
              <div className="input_wrapper">
                <label htmlFor="accountName">Account name</label>
                <input
                  type="text"
                  name="accountName"
                  placeholder="account name"
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="password"> Password </label>
                <input type="text" name="password" placeholder="********" />
              </div>
            </div> */}
            <div className="input_form-mid">
              <div className="input_wrapper">
                <label htmlFor="Email">Email</label>
                <Select
                  isLoading={isLoading}
                  placeholder={"Search for a user"}
                  styles={emailSelectorStyles}
                  options={emailOpts}
                  className="email-selector"
                  classNamePrefix="react-select"
                  onInputChange={(value) => handleOninputChange(value)}
                  onChange={(selectedOption) =>
                    setData((prev) => ({ ...prev, user: selectedOption.value }))
                  }
                />
              </div>
            </div>
            <div className="input_wrapper">
              <label htmlFor="">Broker</label>
              <Select
                className="plan_selector"
                options={brokerOptions}
                styles={customStyles}
                value={broker}
                isSearchable={false}
                isDisabled={selectedBrand?.brand === "crypto_edge"}
                onChange={(selectedOption) => {
                  setData((prev) => ({
                    ...prev,
                    broker: selectedOption.value,
                  }));
                  setBroker(selectedOption);
                  handleSelectCompetitionChange(selectedOption);
                }}
              />
            </div>
            <div className="input_form-btm">
              <div className="input_wrapper">
                <label htmlFor="">Plan Type</label>
                <Select
                  className="plan_selector"
                  options={planOptions}
                  styles={customStyles}
                  value={selectedOption}
                  onChange={handleSelectChange}
                  isSearchable={false}
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="">Account Size</label>
                <Select
                  className="plan_selector"
                  options={competitonOptions}
                  isSearchable={false}
                  styles={customStyles}
                  // value={selectedCompetition}
                  onChange={(selectedOption) => {
                    setData((prev) => ({
                      ...prev,
                      challenge: selectedOption.value,
                    }));

                    handleSelectCompetitionChange(selectedOption);
                  }}
                />
              </div>
            </div>
            <div className="input_form-btm">
              <div className="input_wrapper">
                <label htmlFor="">Phase</label>
                <Select
                  styles={customStyles}
                  placeholder="Select a Phase"
                  classNamePrefix="react-select"
                  isSearchable={false}
                  options={
                    selectedBrand?.brand === "crypto_edge"
                      ? phaseCryptoOptions
                      : phaseOptions?.filter((item) => {
                          if (selectedOption?.label?.startsWith("1 Step")) {
                            return item.value !== "stage_2";
                          }
                          return true; // Ensure all other cases return true to include the item
                        })
                  }
                  value={phase}
                  isDisabled={
                    selectedOption?.label?.toLowerCase().includes("pro edge") ||
                    selectedOption?.label?.toLowerCase().includes("instant")
                  }
                  onChange={(selectedOption) => {
                    selectedOption.value === null
                      ? setPhase(null)
                      : setPhase(selectedOption);

                    setData((prev) => ({
                      ...prev,
                      phase: selectedOption.value,
                    }));
                  }}
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="">Issue Type</label>
                <Select
                  styles={customStyles}
                  placeholder="Select a Issue Type"
                  classNamePrefix="react-select"
                  isSearchable={false}
                  options={issueTypeOptions}
                  value={selectedIssueType}
                  onChange={(selectedOption) => {
                    console.log("selectedOption", selectedOption);
                    selectedOption.value === null
                      ? setSelectedIssueType(null)
                      : setSelectedIssueType(selectedOption);

                    setData((prev) => ({
                      ...prev,
                      issue_type: selectedOption.value,
                    }));
                  }}
                />
              </div>
            </div>

            <div
              onClick={() => CreateTradingAccount()}
              className="view_details_btn"
            >
              {isSpinner ? (
                <CircularProgress color="inherit" />
              ) : (
                "Create Account"
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTradingAccount;
